/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
// Components
import {Heading, Flex, Skeleton} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import Search from '../../../components/search'
import {SearchIcon} from '../../../components/icons'

const PageHeader = ({productSearchResult, isLoading, searchQuery, ...otherProps}) => {
    const {formatMessage} = useIntl()

    return (
        <Flex direction="column" gap={8} alignItems={{lg: 'center'}} {...otherProps}>
            <Search
                placeholder={formatMessage({
                    id: 'global.search',
                    defaultMessage: 'Search'
                })}
                variant="flushed"
                leftIcon={<SearchIcon boxSize={4} />}
                searchQuery={searchQuery}
            />
            {searchQuery && (
                <Skeleton isLoaded={!isLoading}>
                    <Heading as="h2" size="lg">
                        <FormattedMessage
                            defaultMessage='{count} results for "{search}"'
                            values={{count: productSearchResult?.total || 0, search: searchQuery}}
                            id="product_list.search.headline"
                        />
                    </Heading>
                </Skeleton>
            )}
        </Flex>
    )
}

PageHeader.propTypes = {
    productSearchResult: PropTypes.object,
    isLoading: PropTypes.bool,
    searchQuery: PropTypes.string
}

export default PageHeader
